import React, {useEffect, useState} from "react";
import { Table,message, Col, Row, ConfigProvider } from 'antd';
import { sendHttpPostRequest } from "../../../api/http-request";
import globalStyles from "../../common/global-styles/idatacourse-table.module.less"
import "../course.module.css";
import zhCN from 'antd/lib/locale/zh_CN'
import {checkUserLogin} from "../../common/user-center/user-info";
import { EyeOutlined } from '@ant-design/icons';
import courseMainStyles from "../course-main.module.less";
import courseMainTestListStyles from './course-main-teacher-test-list.module.less';
import zuoyeEmpty from "../../../static/image/empty/queshengye-zuoye.png";
import Cookies from "js-cookie";



import Icon from '@ant-design/icons'
import  {ReactComponent as myplusSvg }   from '../../../static/image/course/myplus.svg'
const myplusIcon = (props:any) => (<Icon component={myplusSvg} {...props} />)

import  {ReactComponent as clockredSvg }   from '../../../static/image/course/clock-red.svg'
const clockredIcon = (props:any) => (<Icon component={clockredSvg} {...props} />)
import  {ReactComponent as clockgreenSvg }   from '../../../static/image/course/clock-green.svg'
const clockgreenIcon = (props:any) => (<Icon component={clockgreenSvg} {...props} />)
import  {ReactComponent as clockpurpleSvg }   from '../../../static/image/course/clock-purple.svg'
const clockpurpleIcon = (props:any) => (<Icon component={clockpurpleSvg} {...props} />)
import  {ReactComponent as calendargreenSvg }   from '../../../static/image/course/calendar-check.svg'
const calendargreenIcon = (props:any) => (<Icon component={calendargreenSvg} {...props} />)
import  {ReactComponent as calendarredSvg }   from '../../../static/image/course/calendar-close-line.svg'
const calendarredIcon = (props:any) => (<Icon component={calendarredSvg} {...props} />)


import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
import { ReactComponent as publishSvg }   from '../../../static/image/course/publish.svg'
import { ReactComponent as deleteSvg }   from '../../../static/image/module/delete.svg'

const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
const publishIcon = (props:any) => (<Icon component={publishSvg} {...props} />)
const deleteIcon = (props:any) => (<Icon component={deleteSvg} {...props} />)


export interface Props {
    course_id : any,
    college_id: any,
    menu_id : any
}
/** 学生课程作业列表页面 */
export const CourseMainStudentTestList: React.FC<Props> = (props) => {
    const {course_id,college_id,menu_id} = props;
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
    const [homeworkList, setHomeworkList] = useState([] as any[]);
   
    const statusStyles= (testStatus: string) => {
      if (testStatus == '进行中') {
        return {color:'#0ea5e9', background:'#0ea5e91a'}
      } else if (testStatus == '未发布') {
        return {color:'#6b7280', background:'#6b72801a'}
      }  else if (testStatus == '已完成') {
        return {color:'#10b981', background:'#10b9811a'}
      }

    }

    /**
     * 查询作业回调
     * @param response
     */
    const queryHomeworkListCallback = (response:any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
        } else if (response.code == -501) {
            // 没权限
            message.error("权限不足");
        } else if (response.is_ok == true) {
            setHomeworkList(response.query_list);
        }
    }

    // 查询作业列表
    const queryHomeworkList = () => {
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            sendHttpPostRequest(
                'homework/api/user_query_homework_list/',
                {
                    sessionid: Cookies.get("sessionid"),
                    course_id: course_id,
                    college_id: college_id
                },
                queryHomeworkListCallback
            )
        }
    }

    /**
     * 删除作业回调
     * @param response
     */
    const deleteHomeworkCallback = (response:any) => {
        message.destroy();
        if (response.code == -100) {
            // 没登录
                    sessionStorage.setItem("previousurl",window.location.href )
                    document.getElementById("show-login-modal")!.click();
        } else if (response.code == -501) {
            // 没权限
            message.error("权限不足");
        } else if (response.is_ok == true) {
            //message.success("删除作业成功~");
            queryHomeworkList();
        } else {
            message.error("删除作业失败~");
        }
    }

    /** 删除作业 */
    const deleteHomework = (homeworkId:any) => {
        if (!checkUserLogin()) {
            document.getElementById("show-login-modal")!.click();
        } else {
            sendHttpPostRequest(
                'homework/api/user_delete_homework/',
                {
                    sessionid: Cookies.get("sessionid"),
                    sid: Cookies.get("sessionid"),
                    homework_id: homeworkId,
                },
                deleteHomeworkCallback
            )
        }
    }

    // 渲染操作
    const renderActions = (text:any, record:any) => {
        return <Row  align='middle' justify='center' gutter={[16,8]}> 
          <Col>  <EyeOutlined  value={record?.id} onClick={onPreviewTestClick.bind(this,record?.id,record?.status)}  className={courseMainTestListStyles.actionBtn} /> </Col>
        </Row>
    }

    const onPreviewTestClick = (test_id:string, test_status: any, event:any) => {
      if (!checkUserLogin()) {
          document.getElementById("show-login-modal")!.click();
      } else {

          window.open('/course-student-test-preview?test_id=' + test_id  + '&course_id=' + course_id + '&menu_id=' + menu_id);
      }
    }
    
    const rowSelection = {
      selectedRowKeys,
      onChange: (keys) => {
        setSelectedRowKeys(keys);
      },
    };



    const renderTitle = (text:any, record:any) => {
        let _jumpUrl = '/course-student-test-preview?test_id=' + record.id + '&course_id=' + course_id + '&menu_id=' + menu_id;
        if (record.name.length > 50) {
          return <>
            <a className={courseMainTestListStyles.slideName} href={_jumpUrl} target="_blank">{record.name.slice(0,50) + '...'}</a>
          </>
        } else {
          return <>
            <a className={courseMainTestListStyles.slideName} href={_jumpUrl} target="_blank">{record.name}</a>
          </>
        }
    }

    const testCols :any= [
      {
        title:'序号',
        dataIndex: 'id',
        key: 'id',
        align: 'center',
        width: '80px', 
        render: (text, record)=>(homeworkList?.indexOf(record) + 1),
      },
      {
        title: '作业',
        dataIndex: 'name',
        key: 'name',
        align: 'left',
        width: '250px',
        render:renderTitle,
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: '80px',
      },
      {
        title: '发布时间',
        dataIndex: 'update_time',
        key: 'update_time',
        align: 'center',
        width: '160px',
        ellipsis: true,
        render:(text,record)=>(text?.slice(0,16)),
        //sorter:(a,b) => {
        //    if (moment(a.update_time)  >= moment(b.update_time)) {return 1} else {return -1} }
      },
      {
        title: '截止时间',
        dataIndex: 'submit_time',
        key: 'submit_time',
        align: 'center',
        width: '160px',
        render:(text,record)=>(text?.slice(0,16))
      },
      /*{
        title: '延迟',
        dataIndex: 'deadline',
        key: 'deadline',
        align: 'center',
        width: '20%',
        render:(text, record)=>{
            if(record.allow_delay == 1){
                return <div>{text?.slice(0,16)}</div>
            }else{
                return <div>{"--"}</div>
            }
        }
      },*/
      {
        title: "操作",
        dataIndex: "actions",
        key: "actions",
        width: '100px',
        ellipsis: false,
        align: 'center',
        //fixed: 'right',
        render: renderActions,
    },
    ]

    useEffect(()=> {
        queryHomeworkList();
    },[])



    return (     
        <div >
          <Row align={"middle"} gutter={[24,24]}>
            {
              homeworkList?.map((test, testIndex)=>(
                  <Col span={24} key={testIndex}>
                    <div className={courseMainTestListStyles.testCard}>
                        <Row wrap={false} align={"top"}>
                            <Col flex={"auto"} style={{textAlign:'left'}}>
                              <div>
                                  <div className={courseMainTestListStyles.testCardTitle} > {test?.name} <span className={courseMainTestListStyles.statusSpan} style={statusStyles(test?.status)}> {test?.status} </span></div>
                                  <div className={courseMainTestListStyles.testCardDesp} > {test?.description}</div>
                                  <div className={courseMainTestListStyles.testCardTimeDiv}> 
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={calendargreenIcon}/> 发布时间:  {test?.create_time} </span>
                                    <span className={courseMainTestListStyles.testCardTimeItem} > <Icon component={calendarredIcon}/> 截止时间:  {test?.submit_time} </span>
                                    { test?.allow_delay !== 0 && <span className={courseMainTestListStyles.testCardTimeItem}  > <Icon component={calendarredIcon}/>  延迟提交:  {test?.deadline}</span>}
                                  </div>
                              </div>
                            </Col>
                            <Col flex={"300px"} style={{textAlign:'right'}}>
                              <div>
                                <span  style={{fontSize:14, padding:'6px 12px', marginLeft:12}} className={courseMainStyles.BtnLight} onClick={onPreviewTestClick.bind(this,test?.id,test?.status)}  > <Icon component={eyeIcon}/> 查看 </span>            
                              </div>
                            </Col>                            
                        </Row>
                    </div>
                  </Col>
              ))
            }
          </Row>      

            {homeworkList.length==0 &&
                <div style={{textAlign:'center',paddingTop:20}}>
                    <img src={zuoyeEmpty} width={120} height={120}/>
                    <div style={{color:'#999',marginTop:10}}>老师还没有布置作业哟~</div>
                </div>
            }
        
        </div>
    )

}

export default CourseMainStudentTestList

